import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import styled from 'styled-components';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { requisicaoProps } from '../../atoms/Props';
import { downloadFile, removeUplodadedFile, upload, viewUploadFile } from '../../../services/upload';

const ButtonAnexar = styled(Button)`
  border: 1px dashed #d9d9d9 !important;
`;

function UploadArquivo({ files, requisicao, onChangeFiles }) {
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (files && files.length > 0) {
      setFileList(
        files.map((file) => ({
          uid: file.id,
          name: file.nomeArquivo,
          status: 'done',
          url: '',
        }))
      );
    } else {
      setFileList([]);
    }
  }, [files, requisicao]);

  return (
    <Upload
      name="file"
      accept="image/png,image/jpeg,image/jpg,application/pdf,application/zip,application/x-zip-compressed,application/x-rar-compressed,application/octet-stream"
      customRequest={() => {}}
      beforeUpload={async (file) => {
        try {
          const { data: id } = await upload(file, requisicao);
          const newFileList = [
            ...fileList,
            {
              uid: id,
              name: file.name,
              status: 'done',
              url: '',
            },
          ];
          if (onChangeFiles) {
            onChangeFiles(
              newFileList.map((anexo) => ({
                id: anexo.uid,
                nomeArquivo: anexo.name,
              }))
            );
          }
          setFileList(newFileList);
        } catch (e) {
          mostrarErro(e);
        }
      }}
      multiple
      maxCount={30}
      onRemove={(file) => {
        removeUplodadedFile(file.uid);
        const newFileList = fileList.filter((f) => f.uid !== file.uid);
        setFileList(newFileList);
        if (onChangeFiles) {
          onChangeFiles(
            newFileList.map((anexo) => ({
              id: anexo.uid,
              nomeArquivo: anexo.name,
            }))
          );
        }
      }}
      showUploadList={{ showDownloadIcon: true }}
      onDownload={async (file) => {
        const { data: signedURL } = await viewUploadFile(file.uid);
        downloadFile(file.name, signedURL);
      }}
      fileList={fileList}
    >
      <ButtonAnexar>
        <UploadOutlined /> Adicionar Arquivos
      </ButtonAnexar>
    </Upload>
  );
}

UploadArquivo.propTypes = {
  files: PropTypes.arrayOf(PropTypes.object.isRequired),
  requisicao: requisicaoProps,
  onChangeFiles: PropTypes.func,
};

UploadArquivo.defaultProps = {
  files: [],
  requisicao: {},
  onChangeFiles: () => false,
};

export default UploadArquivo;
